import { DatePipe, LowerCasePipe, NgClass, NgOptimizedImage } from '@angular/common';
import { Component, inject, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { AmlScanEntity, Exposure, LatestAmlReport, OutgoingTransaction } from '../../../../../../../api/api.model';
import { CropWithDotsCenterPipe } from '../../../../../../pipes/crop-with-dots-center.pipe';
import { CopyButtonComponent } from '../../../../../copy-button/copy-button.component';
import { ReportExposuresComponent } from '../../../../../report-partial/report-exposures/report-exposures.component';
import {
  ReportIdentificationComponent
} from '../../../../../report-partial/report-identification/report-identification.component';
import { ReportTriggersComponent } from '../../../../../report-partial/report-triggers/report-triggers.component';
import { ConvertNetworkToTokenPipe } from '../../../../../../pipes/convert-netwrok-to-token.pipe';

@Component({
  selector: 'app-wallet-scan',
  imports: [
    NgOptimizedImage,
    NgClass,
    DatePipe,
    CopyButtonComponent,
    CropWithDotsCenterPipe,
    MatTabsModule,
    ReportIdentificationComponent,
    ReportExposuresComponent,
    ReportTriggersComponent,
    MatIconModule,
    LowerCasePipe,
    ConvertNetworkToTokenPipe
  ],
  templateUrl: './wallet-scan.component.html',
  styleUrl: './wallet-scan.component.scss'
})
export class WalletScanComponent {
  public readonly stateIdentifyDescribeDetails: WritableSignal<{ [key: number]: boolean }> = signal({});
  public readonly transaction: InputSignal<AmlScanEntity<LatestAmlReport>> = input.required();
  public readonly stateDetailsTransaction: WritableSignal<boolean> = signal(false);
  public sumExposures = 0;

  private readonly _translateService: TranslateService = inject(TranslateService);
  currentLang = this._translateService.currentLang;

  ngOnInit(): void {
    console.log(this.transaction());
    this.addExpandeInAddresIdentification();
    this.calcSumExposures();
  }

  public toggleDetailsTransaction(): void {
    this.stateDetailsTransaction.set(!this.stateDetailsTransaction());
  }

  public toggleRentalDetail(uuid: number): void {
    this.stateIdentifyDescribeDetails.update((obj: any) => {
      obj[uuid] = !obj[uuid]
      return obj;
    })
  }

  public asOutgoingTransaction(transaction: AmlScanEntity<LatestAmlReport>): AmlScanEntity<OutgoingTransaction> {
    return transaction as AmlScanEntity<OutgoingTransaction>;
  }

  private addExpandeInAddresIdentification(): void {
    const transaction = this.transaction();
    if (transaction.type === 'INCOMING') {
      return;
    }
    let stateIdentifyDescribeDetails: { [key: number]: boolean } = {};
    this.asOutgoingTransaction(transaction).latestAmlReport?.addressIdentifications.forEach((_, index) => {
      stateIdentifyDescribeDetails[index] = false;
    });
    this.stateIdentifyDescribeDetails.set(stateIdentifyDescribeDetails);
  }

  private calcSumExposures(): void {
    const transaction = this.transaction();
    if (transaction.type === 'INCOMING') {
      return;
    }

    this.asOutgoingTransaction(transaction).latestAmlReport?.exposures?.forEach((exposure: Exposure) => {
      this.sumExposures += exposure.value;
    });
  }

}
